// Use to check the only defined types
export const TYPE = {
	SEPARATOR: "separator",
	ASSIGNER: "assigner",
	LOGICAL: "logical",
	OPERATOR: "operator",
	BOOLEAN: "boolean",
	IDENTIFIER: "identifier",
	STRING: "string",
	NUMBER: "number",
	UNDEFINED: "undefined",
};

export const syntax = new Map([
	["and", "AND"],
	[",", "AND"],
	["&", "AND"],
	["not", "NOT"],
	["~", "NOT"],
	["!", "NOT"],
	["or", "OR"],
	["|", "OR"],
	["greater-than-or-equals-to", ">="],
	["less-than-or-equals-to", "<="],
	["greater-than", ">"],
	["less-than", "<"],
]);

export const baseLexicalCharacters = [
	{ type: "separator", symbol: "[" },
	{ type: "separator", symbol: "]" },
	{ type: "separator", symbol: "(" },
	{ type: "separator", symbol: ")" },
	{ type: "assigner", symbol: ":" },
	{ type: "logical", symbol: "," },
	{ type: "logical", symbol: "AND" },
	{ type: "logical", symbol: "OR" },
	{ type: "logical", symbol: "NOT" },
	{ type: "operator", symbol: ">" },
	{ type: "operator", symbol: "<" },
	{ type: "operator", symbol: ">=" },
	{ type: "operator", symbol: "<=" },
	{ type: "boolean", symbol: `"false"` },
	{ type: "boolean", symbol: `"true"` },
];
